import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import {DRAWER_WIDTH} from '../../launcher-style-consts';
import {PresetsComponent} from '../presets/presets.component';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import {observer} from 'mobx-react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {LauncherLinksComponent} from '../launcher-links/launcher-links.component';
import {getDrawerWidth} from "../../utils/get-drawer-width";


const styles = (theme: Theme) => createStyles ({
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: getDrawerWidth(),
            flexShrink: 0,
        }
    },
    drawerPaper: {
        width: DRAWER_WIDTH,
    },
    toolbar: theme.mixins.toolbar

});

export interface LauncherDrawerComponentProps extends WithStyles<typeof styles> {

}


export const LauncherDrawerComponent = withStyles(styles)(
  observer(
      class extends LauncherComponentBase<LauncherDrawerComponentProps> {

          private _renderPresets() {
              return this.services.presets.presetsCategories.map(category => (<PresetsComponent key={category.title} title={category.title} presets={category.presets}/>));
          }

          private _renderDrawerContent() {
              return (
                  <>
                      <LauncherLinksComponent/>
                      {this._renderPresets()}
                  </>

              );
          }
          private _renderPCDrawer() {
              return (
                  <Drawer variant="permanent"
                          open
                          classes={{paper: this.props.classes.drawerPaper}}>
                      {this._renderDrawerContent()}
                  </Drawer>
              );
          }

          private _renderMobileDrawer() {
              return (
                  <Drawer variant="temporary"
                          anchor="left"
                          open={this.services.drawer.isDrawerOpen}
                          classes={{paper: this.props.classes.drawerPaper}}
                          onClose={() => this.services.drawer.toggleDrawer()}
                          ModalProps={{keepMounted: true}}>
                      {this._renderDrawerContent()}
                  </Drawer>
              );
          }

          render() {

              return (
                  <nav className={this.props.classes.drawer}>
                      {this.services.deviceTypeDetection.isMobile ? this._renderMobileDrawer() : this._renderPCDrawer()}
                  </nav>
              );
          }
      }
  )
);

